import React, { useEffect, useState, ChangeEvent } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  FormGroup,
  FormControl,
  Select,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Typography,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import userProfile from '../../../../assets/images/userProfile.svg';
import profileDelete from '../../../../assets/images/profileDeleteIcon.svg';
import { closeIcon } from '../../../../assets/images/index';
import { PasswordInput } from '../../../../components/TextFields';
import { useAlert } from '../../../../components/Notification';
import createAxiosInstance from '../../../../api';
import { hashPassword } from '../../../../constant/constant';
import Popup from '../../../../components/Popup';
import CropComponent from '../../../../components/crop';
import { useForm } from 'react-hook-form';
import { useHook as UserManagementHook } from './useHook';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import { Unauthorized } from '../../../../components/index';
import { ErrorMessage } from '../../../../permissionErrorMessage/PermissionMessage';

interface roles {
  roleName: string;
  roleID: string;
}

interface PermissionTable {
  data: roles[];
  assignedRole: string[];
}

interface Props {
  pagePermissionIDs: unknown;
}

type ImageString = string;
type SetImageString = React.Dispatch<React.SetStateAction<ImageString>>;

const CreateUser: React.FC<Props> = ({ pagePermissionIDs }) => {
  const axiosInstance = createAxiosInstance();
  const { fetchUserDetails } = UserManagementHook();
  const showAlert = useAlert();
  const location = useLocation();
  const { id: paramid } = useParams();
  const [roles, setrole] = useState<roles[]>([]);
  const navigate = useNavigate();
  const editData = location.state && location.state.user;
  const [countryCode, setCountryCode] = useState('+91');
  const [roleIDs, setRoleIDs] = useState<string[]>([]);
  const [mobileNumberError, setMobileNumberError] = useState('');
  const [userEmailError, setUserEmailError] = useState('');
  const [userPasswordError, setuserPasswordError] = useState('');
  const [roleError, setRoleError] = useState('');
  const [profileError, setProfileError] = useState('');
  const [imageString, setImageString]: [ImageString, SetImageString] =
    useState('');
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteid, setDeleteid] = useState<string>('');
  const [dialogText, setDialogText] = useState('');
  const [assignRole, setAssignRole] = useState<string[]>([]);
  const [password, setPassword] = useState('');
  const [isPasswordValid, setisPasswordValid] = useState(false);
  const [opencrop, setOpenCrop] = useState(false);
  const [filteredRole, setFilteredRole] = useState<roles[]>([]);
  const [roleSearch, setRoleSearch] = useState('');
  const [uploadError, setUploadError] = useState('');

  const handleRoleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRoleSearch(event.target.value);
    const query = event.target.value.toLowerCase();
    const filtered = roles?.filter((role: any) =>
      role?.roleName?.toLowerCase().includes(query),
    );
    setFilteredRole(filtered);
  };

  const canupdatePasswordUsers =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('users::updatePassword');
  const canchangeUserStatususers =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('users::changeUserStatus');
  const canupdateusers =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('users::update');
  const canGetUser =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('users::get');
  const requiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['users::get'] || ''}</li>
      </ul>
    </section>
  );
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
  } = useForm();

  const fetchImage = async (imageUrl: RequestInfo | URL) => {
    if (imageUrl) {
      try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();

        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result) {
            const base64String = reader.result.toString().split(',')[1]; // Extracting base64 string
            const imageString = `data:image/png;base64,${base64String}`;
            setCroppedImages(imageString); // Set the base64 string to state
            console.log(imageString, 'imageData');
          }
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.error('Failed to fetch image:', error);
      }
    }
  };

  const getoneUserDetails = async (id: string) => {
    await fetchUserDetails({ userID: id }).then((res: any) => {
      fetchImage(res?.avatar);
      setValue('firstName', res?.firstName || '');
      setValue('lastName', res?.lastName || '');
      setValue('phoneNumber', res?.phoneNumber || '');
      setValue('email', res?.primaryEmail || '');
      setValue('role', res?.roles || []);
      // setImageString(res?.avatar);
      setCountryCode('+91');
      setAssignRole(res?.roles ? res?.roles : []);
    });
  };

  useEffect(() => {
    if (paramid && canGetUser) {
      getoneUserDetails(paramid);
    }
  }, [paramid, canGetUser]);

  const [croppedImage, setCroppedImages] = useState<string | null>(null);

  const handleCropComplete = (croppedImage: string) => {
    setCroppedImages(croppedImage);
    setOpenCrop(false);
    setUploadError('');
  };

  const getRoleList = () => {
    axiosInstance
      .post('/listRole', {})
      .then((response) => {
        setrole(response.data.data);
        setFilteredRole(response.data.data);
        setRoleIDs(response.data.data.map((param: roles) => param.roleID));
      })
      .catch(() => {
        setrole([]);
        setFilteredRole([]);
      });
  };

  const handleDeleteRole = (param: string) => {
    setAssignRole(assignRole.filter((a) => a != param));
    setValue(
      'role',
      assignRole.filter((a) => a != param),
    );
  };

  const validation = (validate?: string, formData?: any) => {
    let valid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (validate == 'password') {
      if (password?.length < 7) {
        setuserPasswordError('Password must be at least 8 characters long.');
        valid = false;
      }
    } else {
      if (!emailRegex.test(formData?.email)) {
        setUserEmailError('Invalid email address');
        valid = false;
      }
      if (!phoneRegex.test(formData?.phoneNumber)) {
        setMobileNumberError('Invalid mobile number');
        valid = false;
      }

      if (opencrop) {
        console.log(opencrop, 'opencropopencropopencrop');
        setUploadError('Please upload the image');
        valid = false;
      }

      // if (password?.length > 0) {
      //   setuserPasswordError('Update your password');
      //   valid = false;
      // }

      if (countryCode?.length <= 0 && formData?.phoneNumber?.length > 0) {
        setMobileNumberError('Country code is required');
        valid = false;
      }
      if (formData?.role?.length <= 0) {
        setRoleError('Role is required');
        valid = false;
      }
    }

    return valid;
  };

  const handlesubmit = (userData: any) => {
    if (validation('', userData)) {
      const imageType = croppedImage?.substring(11, croppedImage?.indexOf(';'));
      const imageWithoutPrefix = croppedImage?.substring(
        croppedImage?.indexOf(',') + 1,
      );
      const createpayload = {
        firstName: userData?.firstName,
        lastName: userData?.lastName,
        email: userData?.email,
        roles: userData?.role,
        phoneNumber: userData?.phoneNumber,
        avatar: imageWithoutPrefix,
        ext: imageType,
      };

      const userid = paramid;

      const updatepayload = {
        userID: userid,
        firstName: userData?.firstName,
        lastName: userData?.lastName,
        roles: userData?.role,
        phoneNumber: userData?.phoneNumber,
        avatar: imageWithoutPrefix,
        ext: imageType,
      };

      const url = userid ? '/updateUser' : '/createUser';
      const payload = userid ? updatepayload : createpayload;

      axiosInstance
        .post(url, payload)
        .then(() => {
          showAlert(
            `User ${userid ? 'Update' : 'Created'} successfully`,
            'success',
          );
          navigate('/iam/user');
        })
        .catch(() => {
          showAlert(`Failed to ${userid ? 'Update' : 'Created'} User`, 'error');
        });
    }
  };

  const validateImage = (
    file: File,
    setProfileError: (error: string) => void,
  ): boolean => {
    const allowedTypes: string[] = ['image/jpeg', 'image/png', 'image/gif'];
    const maxFileSize: number = 1024 * 1024; // 1MB

    if (!allowedTypes.includes(file.type)) {
      setProfileError('Please select a JPG, GIF, or PNG file.');
      return false;
    }

    if (file.size > maxFileSize) {
      setProfileError('File size exceeds the 1MB limit.');
      return false;
    }

    return true;
  };

  const toBase64 = (file: Blob) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        } else {
          reject(new Error('Failed to read file as Data URL'));
        }
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const file: File | null = e.target.files ? e.target.files[0] : null;

    if (file && validateImage(file, setProfileError)) {
      setProfileError('');

      await toBase64(file)
        .then((base64String) => {
          setImageString(base64String as string);
          setCroppedImages(base64String as string);
          setOpenCrop(true);
        })
        .catch(() => {
          setImageString('');
          setCroppedImages('');
          showAlert(`Failed to Upload Image.`, 'error');
          setOpenCrop(false);
        });
    }
  };

  const handleDeleteImage = () => {
    setImageString('');
    setCroppedImages('');
    setUploadError('');
    const uploadInput = document.getElementById(
      'upload-button',
    ) as HTMLInputElement;
    if (uploadInput) {
      uploadInput.value = '';
    }
  };

  const changeUserStatus = (type: string) => {
    axiosInstance
      .post('/changeUserStatus', {
        userID: editData.userID,
        status: type == 'activate' ? 'active' : type,
      })
      .then(() => {
        navigate('/iam/user');
        showAlert(
          `User ${type == 'suspend' ? 'Suspend' : 'Delete'} successfully`,
          'success',
        );
      })
      .catch(() => {
        showAlert(
          `Failed to ${type == 'suspend' ? 'Suspend' : 'Delete'} User`,
          'error',
        );
      });
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    event.preventDefault(); // Prevents submission
    updateUserPassword(password);
  };

  const updateUserPassword = (password: string) => {
    if (validation('password')) {
      axiosInstance
        .post('/updateUserPassword', {
          userID: editData.userID,
          password: hashPassword(password),
        })
        .then(() => {
          setPassword('');
          showAlert(`Update Password successfully`, 'success');
        })
        .catch(() => {
          showAlert(`Failed to Update Password`, 'error');
        });
    }
  };

  const findrolename = (roleid: string) => {
    if (roles?.length > 0) {
      if (roleid) {
        const findrole = roles.find((param: roles) => param.roleID == roleid);
        return findrole?.roleName ? findrole?.roleName : roleid;
      } else {
        return roleid;
      }
    } else {
      return roleid;
    }
  };

  const PermissionTable = ({ data, assignedRole }: PermissionTable) => {
    return (
      <>
        {/* <div className="usermanagement_create"> */}
        {data.map((group: roles) => (
          <>
            <TableRow key={group.roleID} className="usermanagement_create_user">
              <TableCell colSpan={2}>
                {assignedRole.includes(group.roleID) ? (
                  <IconButton
                    className="iconButton"
                    onClick={() => {
                      setAssignRole(
                        assignRole.filter((param) => param != group.roleID),
                      );
                      setValue(
                        'role',
                        assignRole.filter((param) => param != group.roleID),
                      );
                    }}
                  >
                    <DoneIcon className="doneIcon" />
                  </IconButton>
                ) : (
                  <IconButton
                    className="iconButton1"
                    onClick={() => {
                      setAssignRole(
                        !assignRole.includes(group.roleID)
                          ? [...assignRole, group.roleID]
                          : assignRole,
                      );
                      setValue(
                        'role',
                        !assignRole.includes(group.roleID)
                          ? [...assignRole, group.roleID]
                          : assignRole,
                      );
                    }}
                  ></IconButton>
                )}
                {/* {convertToCamelCase(group.roleName)} */}
                {group.roleName}
              </TableCell>
            </TableRow>
          </>
        ))}
        {/* </div> */}
      </>
    );
  };

  useEffect(() => {
    getRoleList();
  }, []);

  return (
    <>
      {!canGetUser && paramid ? (
        <Unauthorized requiredAccess={requiredAccess} />
      ) : (
        <>
          {deletePopup && (
            <Popup
              open={deletePopup}
              btntext={deleteid}
              dialogText={dialogText}
              handleClose={() => {
                setDeletePopup(false);
              }}
              handleDelete={() => {
                changeUserStatus(deleteid);
              }}
              page="user"
            />
          )}
          <div className="create_user_management">
            <form onSubmit={handleSubmit(handlesubmit)}>
              <FormControl className="w-100">
                <div className="row d-flex  w-100">
                  <div className="col-md-6">
                    <Typography variant="h6">
                      <b>Name</b>
                    </Typography>
                    <Typography
                      variant="body2"
                      className="create_user_formlabel"
                    >
                      Provide first name and last name of new user
                    </Typography>
                  </div>
                  <div className="col-md-6  p-0 ">
                    <FormGroup>
                      <div className="create_user_name">
                        <TextField
                          className="create_user_name_input"
                          id="firstName"
                          variant="outlined"
                          {...register('firstName', { required: true })}
                          onChange={() => clearErrors('firstName')}
                          error={errors.firstName ? true : false}
                          placeholder="First Name"
                        />
                        <TextField
                          className="create_user_name_input"
                          id="lastName"
                          {...register('lastName', { required: true })}
                          onChange={() => clearErrors('lastName')}
                          error={errors.lastName ? true : false}
                          variant="outlined"
                          placeholder="Last Name"
                        />
                      </div>
                    </FormGroup>
                    {(errors.firstName || errors.lastName) && (
                      <span className="text-danger">
                        {'User name is required'}
                      </span>
                    )}
                  </div>
                </div>
                <hr />
                <div className="row d-flex  w-100">
                  <div className="col-md-6">
                    <h6 className="m-0">
                      <b>Profile Picture</b>
                    </h6>
                  </div>
                  <div className="col-md-6 p-0">
                    <div className="create_user_profile-container">
                      <div className="create_user_profile">
                        <div>
                          {croppedImage ? (
                            <img
                              src={croppedImage}
                              width={72}
                              alt="User Profile"
                            />
                          ) : (
                            <img
                              src={userProfile}
                              width={72}
                              alt="User Profile"
                            />
                          )}
                        </div>
                        <div>
                          <label
                            // variant="outlined"
                            // component="label"
                            htmlFor="upload-button"
                            className="custom-file-upload"
                          >
                            Change
                          </label>
                          <input
                            type="file"
                            accept="image/*"
                            id="upload-button"
                            onChange={(e) => handleFileChange(e)}
                          />
                        </div>
                        <div className="imageformat">
                          <p>JPG, GIF, or PNG. 1MB Max.</p>
                        </div>
                      </div>
                      {croppedImage && (
                        <Button
                          className="create_user_profile-delete"
                          onClick={() => handleDeleteImage()}
                        >
                          <img
                            src={profileDelete}
                            width={44}
                            alt="delete icon"
                          />
                        </Button>
                      )}
                    </div>
                    {profileError && (
                      <span className="text-danger">{profileError}</span>
                    )}
                    {opencrop && croppedImage && (
                      <CropComponent
                        srce={croppedImage}
                        onCropComplete={handleCropComplete}
                        uploadError={uploadError}
                      />
                    )}
                  </div>
                </div>
                <hr />
                <div className="row d-flex  w-100">
                  <div className="col-md-6">
                    <h6 className="m-0">
                      <b>Contact Number</b>
                    </h6>
                    <p className="m-0 create_user_formlabel">
                      Provide contact number
                    </p>
                  </div>
                  <div className="col-md-6  p-0 ">
                    <FormGroup>
                      <div className="create_user_name">
                        <Select
                          className="form-countrycode"
                          id="countrycode"
                          value={'+91'}
                          onChange={(e) => {
                            setCountryCode('+91'), setMobileNumberError('');
                          }}
                          error={
                            mobileNumberError || errors.phoneNumber
                              ? true
                              : false
                          }
                          variant="outlined"
                        >
                          <MenuItem value="+91">+91</MenuItem>
                        </Select>
                        <TextField
                          className="form-mobile"
                          id="phoneNumber"
                          placeholder="Phone number"
                          {...register('phoneNumber', { required: true })}
                          inputProps={{ maxLength: 10 }}
                          onChange={(e) => {
                            const sanitizedValue = e.target.value.replace(
                              /\D/g,
                              '',
                            );
                            if (sanitizedValue.length <= 10) {
                              setValue('phoneNumber', sanitizedValue);
                              clearErrors('phoneNumber');
                            }
                            setMobileNumberError('');
                          }}
                          variant="outlined"
                          error={
                            mobileNumberError || errors.phoneNumber
                              ? true
                              : false
                          }
                        />
                      </div>
                    </FormGroup>
                    {mobileNumberError && (
                      <span className="text-danger">{mobileNumberError}</span>
                    )}
                    {errors.phoneNumber && (
                      <span className="text-danger">
                        {'Mobile number is required'}
                      </span>
                    )}
                  </div>
                </div>
                <hr />
                <div className="row d-flex  w-100">
                  <div className="col-md-6">
                    <h6 className="m-0">
                      <b>Email Address</b>
                    </h6>
                    <p className="m-0 create_user_formlabel">
                      This is the email address using which user will log in
                    </p>
                  </div>
                  <div className="col-md-6  p-0 ">
                    <FormGroup>
                      <TextField
                        disabled={editData?.userID ? true : false}
                        id="email"
                        {...register('email', { required: true })}
                        error={userEmailError || errors.email ? true : false}
                        placeholder="Email Address"
                        onChange={() => {
                          clearErrors('email');
                          setUserEmailError('');
                        }}
                        variant="outlined"
                        fullWidth
                      />
                    </FormGroup>
                    {userEmailError && (
                      <span className="text-danger">{userEmailError}</span>
                    )}
                    {errors.email && (
                      <span className="text-danger">{'Email is required'}</span>
                    )}
                  </div>
                </div>
              </FormControl>
              <hr />
              <div className="row d-flex  w-100">
                <div className="col-md-6">
                  <h6 className="m-0">
                    <b>Assign Role</b>
                  </h6>
                  <p className="m-0 create_user_formlabel">
                    {/* Enter your alternative email for reset password or forgot password */}
                    Select Role
                  </p>
                </div>

                <div className="col-md-6  p-0 ">
                  <FormGroup>
                    <Select
                      labelId="permissions-label"
                      id="role"
                      multiple
                      value={assignRole}
                      placeholder="Add or Remove Roles"
                      {...register('role', { required: true })}
                      onChange={() => clearErrors('role')}
                      error={errors.role ? true : false}
                      variant="outlined"
                      fullWidth
                      displayEmpty
                      renderValue={() => (
                        <div className="dropdown_placeholder_text">
                          Add or Remove Roles
                        </div>
                      )}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            border: '1px solid #D0D5DD99',
                            borderRadius: '8px',
                          },
                        },
                      }}
                    >
                      <div className="select_role_search">
                        <TextField
                          className="selectoption_searchbar search-input"
                          variant="outlined"
                          placeholder="Search Role"
                          fullWidth
                          value={roleSearch}
                          InputProps={{
                            startAdornment: (
                              <SearchIcon className="search_icon" />
                            ),
                          }}
                          onChange={handleRoleSearch}
                        />
                      </div>

                      <div className="tablecontainer">
                        <TableContainer component={Paper} className="table_con">
                          <Table className="create_header">
                            {/* <div className="create_header"> */}
                            {/* <TableHead>
                          <TableCell className="roles">
                            <div className="create_header_user">
                              {assignRole?.length < 1 ? (
                                <IconButton
                                  className="iconButton1"
                                  onClick={() => setAssignRole(roleIDs)}
                                ></IconButton>
                              ) : (
                                <IconButton
                                  className="iconButton"
                                  onClick={() => setAssignRole([])}
                                >
                                  {arraysAreEqual(roleIDs, assignRole) ? (
                                    <DoneIcon className="doneIcon" />
                                  ) : (
                                    <MinusIcon className="minusIcon" />
                                  )}
                                </IconButton>
                              )}
                            </div>
                            Permissions
                          </TableCell>
                        </TableHead> */}
                            <TableBody className="usermanagement_create">
                              <PermissionTable
                                data={filteredRole}
                                assignedRole={assignRole}
                              />
                            </TableBody>
                            {/* </div> */}
                          </Table>
                        </TableContainer>
                      </div>
                    </Select>
                  </FormGroup>
                  {/* {roleError && <span className="text-danger">{roleError}</span>} */}
                  {assignRole.map((role, index) => (
                    <div key={index} className="permission">
                      <p>{findrolename(role)}</p>
                      <Button onClick={() => handleDeleteRole(role)}>
                        <img src={closeIcon} alt="Delete Icon" width={13} />
                      </Button>
                    </div>
                  ))}
                </div>
              </div>
              <hr />
              {paramid ? (
                <>
                  {canupdatePasswordUsers && (
                    <>
                      <div className="row d-flex  w-100">
                        <div className="col-md-6">
                          <h6 className="m-0">
                            <b>Update Password</b>
                          </h6>
                          <p className="m-0 create_user_formlabel">
                            Override password for the user
                          </p>
                        </div>
                        <div className="col-md-6  p-0 ">
                          <FormGroup>
                            <div className="create_user_name">
                              <div className="col-md-8  p-0 ">
                                <FormGroup>
                                  <PasswordInput
                                    label={null}
                                    errorshow={false}
                                    value={password}
                                    handleValid={setisPasswordValid}
                                    onChange={setPassword}
                                    error={isPasswordValid}
                                    onKeyDown={handleKeyDown}
                                  />
                                </FormGroup>
                              </div>
                              <div className="update_password-btn d-flex justify-content-end">
                                <Button
                                  color="primary"
                                  onClick={() => updateUserPassword(password)}
                                >
                                  Update Password
                                </Button>
                              </div>
                            </div>
                            {!isPasswordValid && (
                              <span className="text-danger">
                                {userPasswordError}
                              </span>
                            )}
                          </FormGroup>
                        </div>
                      </div>
                      <hr />
                    </>
                  )}
                  {canchangeUserStatususers && (
                    <>
                      <div className="row d-flex  w-100">
                        <div className="col-md-6">
                          <h6 className="m-0">
                            <b>Change User’s Status</b>
                          </h6>
                          <p className="m-0 create_user_formlabel">
                            Control user access: Delete or suspend user
                          </p>
                        </div>
                        <div className="col-md-6  p-0 ">
                          <FormGroup>
                            <div className="create_user_name">
                              <div className="user_status-btn d-flex justify-content-end">
                                <Button
                                  className="status-delete-btn"
                                  color="primary"
                                  onClick={() => {
                                    setDeleteid('delete');
                                    setDialogText('remove it');
                                    setDeletePopup(true);
                                  }}
                                >
                                  Delete User
                                </Button>
                              </div>
                              {editData?.status ? (
                                <div className="user_status-btn d-flex justify-content-end">
                                  <Button
                                    className="status-suspend-btn"
                                    color="primary"
                                    onClick={() => {
                                      setDeleteid('suspend');
                                      setDialogText('suspend user');
                                      setDeletePopup(true);
                                    }}
                                  >
                                    Suspend User
                                  </Button>
                                </div>
                              ) : (
                                <div className="user_status-btn d-flex justify-content-end">
                                  <Button
                                    className="status-active-btn"
                                    color="primary"
                                    onClick={() => {
                                      setDeleteid('activate');
                                      setDialogText('activate user');
                                      setDeletePopup(true);
                                    }}
                                  >
                                    ACTIVATE
                                  </Button>
                                </div>
                              )}
                            </div>
                          </FormGroup>
                        </div>
                      </div>
                      <hr />
                    </>
                  )}
                </>
              ) : (
                <></>
              )}
              {paramid ? (
                <>
                  {canupdateusers && (
                    <div className="edit-btn d-flex justify-content-end">
                      <Button color="primary" type="submit">
                        Update
                      </Button>
                    </div>
                  )}
                </>
              ) : (
                <div className="submit-btn d-flex justify-content-end">
                  <Button color="primary" type="submit">
                    Save
                  </Button>
                </div>
              )}
            </form>
          </div>
        </>
      )}
    </>
  );
};

export default CreateUser;
